import { Paper, Box } from '@mui/material';
import { styled } from '@mui/system';

export const EducationCard = styled(Paper)(({ theme, position }) => ({
  padding: theme.spacing(3),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
  top: position === 'top' ? '-20px' : '20px',
  zIndex: position === 'top' ? 1 : 0,
  transition: 'all 0.3s ease-in-out',
  borderRadius: '15px',
  background: theme.palette.mode === 'dark'
    ? (position === 'top'
      ? (theme.custom?.gradients?.brandTextDark || 'linear-gradient(135deg, #4B0082 0%, #8A2BE2 100%)')
      : (theme.custom?.gradients?.brand || 'linear-gradient(135deg, #1A2980 0%, #26D0CE 100%)'))
    : (position === 'top'
      ? 'linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%)'
      : 'linear-gradient(135deg, #6A5ACD 0%, #00CED1 100%)'),
  color: theme.palette.common.white,
  boxShadow: theme.palette.mode === 'dark' ? (theme.custom?.shadows?.softDark || '0 10px 20px rgba(0,0,0,0.35)') : '0 10px 20px rgba(0,0,0,0.1)',
  border: theme.palette.mode === 'dark' ? (theme.custom?.glass?.borderDark || '1px solid rgba(255,255,255,0.10)') : undefined,
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.palette.mode === 'dark' ? (theme.custom?.shadows?.glowPrimary || '0 15px 30px rgba(0,0,0,0.55)') : '0 15px 30px rgba(0,0,0,0.2)',
  },
}));

export const Divider = styled(Box)(({ theme }) => ({
  width: '6px',
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.gradients?.brandTextDark || 'linear-gradient(180deg, #4B0082 0%, #1A2980 50%, #26D0CE 100%)')
    : 'linear-gradient(180deg, #FF6B6B 0%, #6A5ACD 50%, #00CED1 100%)',
  height: '90%',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  borderRadius: '4px',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
  },
  '&::before': {
    top: 0,
    background: theme.palette.mode === 'dark' ? '#4B0082' : '#FF6B6B',
  },
  '&::after': {
    bottom: 0,
    background: theme.palette.mode === 'dark' ? '#26D0CE' : '#00CED1',
  },
}));

export const IconWrapper = styled(Box)(({ theme, position }) => ({
  background: theme.palette.mode === 'dark'
    ? (position === 'top' ? '#8A2BE2' : '#1A2980')
    : (position === 'top' ? '#4ECDC4' : '#6A5ACD'),
  color: theme.palette.common.white,
  borderRadius: '50%',
  padding: theme.spacing(2),
  display: 'inline-flex',
  marginBottom: theme.spacing(2),
  boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
}));
